import React from "react";
import PropTypes from "prop-types";

import { Label, FormGroup, Row, Col } from "reactstrap";
import { AvField } from "availity-reactstrap-validation";

const propTypes = {
  spinColor: PropTypes.string,
  spinConfig: PropTypes.object,
  spinAlignment: PropTypes.string,
};

function FormRow({
  label = "",
  type = "text",
  name = "",
  viewonly = false,
  includeRow = true,
  required = true,
  hidelabel = false,
  readonly = false,
  errorMessage = "Required",
  helpMessage = "",
  labelW = "2",
  formW = "7",
  data,
  changeInput,
  style = { width: 130 },
  minLength,
  maxLength,
}) {
  if (hidelabel) {
    if (viewonly) {
      return (
        <Col sm={formW} style={{ textAlign: "right", padding: 10 }}>
          <FormGroup>
            <b>{data}</b>
          </FormGroup>
        </Col>
      );
    }
    return (
      <AvField
        name={name}
        type={type} // text  or textarea
        value={data}
        required={false}
        readOnly={readonly}
        errorMessage={errorMessage}
        helpMessage={helpMessage}
        style={style}
        autoComplete="none"
        onChange={(e) => changeInput && changeInput(e, name)}
        minLength={maxLength}
        maxLength={maxLength}
      />
    );
  }

  let output = (
    <>
      <Label sm={labelW}>{label}</Label>
      <Col sm={formW}>
        <FormGroup>
          <AvField
            name={name}
            type={type} // text  or textarea
            value={data}
            required={required}
            readOnly={readonly}
            errorMessage={errorMessage}
            helpMessage={helpMessage}
            autoComplete="none"
            onChange={(e) => {
              return changeInput && changeInput(e, name);
            }}
            minLength={minLength}
            maxLength={maxLength}
          />
        </FormGroup>
      </Col>

      {required && (
        <Col className="label-on-right" tag="label" sm="3">
          <code>required</code>
        </Col>
      )}
    </>
  );
  if (viewonly) {
    output = (
      <>
        <Label sm={labelW}>{label}</Label>
        <Col sm={formW} style={{ textAlign: "left", padding: 10 }}>
          <FormGroup>
            <b>{data}</b>
          </FormGroup>
        </Col>

        {2 > 3 && (
          <Col className="label-on-right" tag="label" sm="3">
            <code>required</code>
          </Col>
        )}
      </>
    );
  }
  if (includeRow) {
    return <Row>{output}</Row>;
  }
  return output;
}

FormRow.propTypes = propTypes;

export default FormRow;
